export const GoodFitOptions = {
  HighValue: 'HighValue',
  ColdPacked: 'ColdPacked',
  LargeSize: 'LargeSize',
  VapeProduct: 'VapeProduct',
  NoneOfThem: 'NoneOfThem'
}
